import { getMessage } from '../../../utils/messageUtils'
import type { product } from '../../../utils/productUtils'

import './ProductEntry.scss'

interface ProductEntryProps {
  product: product
  isMobile: boolean
  openPopup: (product: product | null) => void
}

function ProductEntry({ product, isMobile, openPopup }: ProductEntryProps) {
  const onClick = () => {
    openPopup(product)
  }
  return (
    <div
      key={product.id}
      className={`list-entry ${isMobile ? 'list-entry-mobile' : ''} ${product.ingredient ? 'list-entry-ingredient' : ''}`}
      onClick={onClick}
    >
      <div className="product-name">
        <span>{product.name}</span>
      </div>
      <div className="product-boolean">
        <span>
          {product.ingredient ? getMessage('product_ingredient_tick') : ''}
        </span>
      </div>
      <div className="product-boolean">
        <span>
          {product.storable ? getMessage('product_storable_tick') : ''}
        </span>
      </div>
      <div className="product-pack">
        <span>{`${product.pack > 1 ? getMessage('product_pack') + product.pack : ''}`}</span>
      </div>
    </div>
  )
}

export default ProductEntry
